const ACCESS_PATCH_USERS_STORAGE_KEY = 'orderly.access.patch.users';
const ACCESS_PATCH_USERS_ENV = process.env.VUE_APP_SCOPED_ACCESS_PATCH_USERS || '';

// ACCESS_PATCH_V2:
// Add one or more user identifiers (email or numeric id) in this list.
// This patch is intentionally centralized here to make it easy to remove.
const ACCESS_PATCH_USERS = Object.freeze([
  'jesus.cordero@humana11.com',
]);

const ACCESS_PATCH_FALLBACK_ROUTE_NAME = 'customers';

const ACCESS_PATCH_ALLOWED_ROUTE_NAMES = new Set([
  'login',
  'recoverPassword',
  'newPassword',
  'invalidDomain',
  'customers',
  'salesMultiCustomer',
]);

const ACCESS_PATCH_ALLOWED_URL_PATHS = new Set([
  '/customers',
  '/sales/multicliente',
]);

const normalizeValue = (value) => String(value || '').trim().toLowerCase();

const normalizePath = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const noHash = raw.split('#')[0];
  const noQuery = noHash.split('?')[0];
  const normalized = noQuery.replace(/\/+$/, '');

  return normalized || '/';
};

const parseUserList = (value) => {
  return String(value || '')
    .split(',')
    .map((item) => normalizeValue(item))
    .filter(Boolean);
};

const getConfiguredScopedUsers = () => {
  const fromCode = ACCESS_PATCH_USERS.map((item) => normalizeValue(item)).filter(Boolean);
  const fromEnv = parseUserList(ACCESS_PATCH_USERS_ENV);
  const fromStorage = parseUserList(localStorage.getItem(ACCESS_PATCH_USERS_STORAGE_KEY));

  return new Set([...fromCode, ...fromEnv, ...fromStorage]);
};

const getStoredSessionUser = () => {
  const raw = localStorage.getItem('user');
  if (!raw || raw === 'undefined') {
    return {};
  }

  try {
    return JSON.parse(raw) || {};
  } catch (error) {
    return {};
  }
};

const getUserCandidateIdentifiers = (user = {}) => {
  return [
    user?.email,
    user?.id,
    user?.user_id,
    user?.uuid,
  ]
    .map((value) => normalizeValue(value))
    .filter(Boolean);
};

export const ACCESS_PATCH_ROUTE_FALLBACK = ACCESS_PATCH_FALLBACK_ROUTE_NAME;

export const isScopedAccessPatchUser = (user = getStoredSessionUser()) => {
  const configuredUsers = getConfiguredScopedUsers();
  if (configuredUsers.size === 0) {
    return false;
  }

  const candidates = getUserCandidateIdentifiers(user);
  if (candidates.length === 0) {
    return false;
  }

  return candidates.some((candidate) => configuredUsers.has(candidate));
};

export const isRouteAllowedForScopedAccessPatch = (route) => {
  const routeName = normalizeValue(route?.name);
  if (routeName && ACCESS_PATCH_ALLOWED_ROUTE_NAMES.has(route.name)) {
    return true;
  }

  const path = normalizePath(route?.path);
  return ACCESS_PATCH_ALLOWED_URL_PATHS.has(path);
};

const filterDropdownOptions = (options = []) => {
  return options.filter((option) => {
    const optionPath = normalizePath(option?.url);
    return ACCESS_PATCH_ALLOWED_URL_PATHS.has(optionPath);
  });
};

const filterSubmenuItem = (item = {}) => {
  if (item?.type === 'dropdown') {
    const allowedOptions = filterDropdownOptions(Array.isArray(item.options) ? item.options : []);
    if (allowedOptions.length === 0) {
      return null;
    }

    return {
      ...item,
      options: allowedOptions,
    };
  }

  const itemPath = normalizePath(item?.url);
  if (!ACCESS_PATCH_ALLOWED_URL_PATHS.has(itemPath)) {
    return null;
  }

  return item;
};

export const filterSidebarSectionsForScopedAccessPatch = (sections = []) => {
  if (!Array.isArray(sections)) {
    return [];
  }

  return sections
    .map((section) => {
      const submenu = Array.isArray(section?.submenu) ? section.submenu : [];
      const allowedSubmenu = submenu
        .map((item) => filterSubmenuItem(item))
        .filter(Boolean);

      if (allowedSubmenu.length === 0) {
        return null;
      }

      return {
        ...section,
        submenu: allowedSubmenu,
      };
    })
    .filter(Boolean);
};